import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { DiscountCode } from '@shared/models/data/DiscountCode';
import { DiscountCodeService } from '@shared/services/administration/discount-code.service';
import { FormValidatorService } from '@shared/services/forms/form-validator.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { finalize } from 'rxjs/operators';
import { ApplicationService } from '@shared/services/administration/application.service';
import { Constants } from '@shared/services/constants/constants';

@Component({
  selector: 'app-add-discount-code-dialog',
  templateUrl: './add-discount-code-dialog.component.html',
  styleUrls: ['./add-discount-code-dialog.component.scss']
})
export class AddDiscountCodeDialogComponent implements OnInit {

  formGroup = new FormGroup({
    discountCode: new FormControl('', Validators.required),
    beginDate: new FormControl(''),
    endDate: new FormControl(''),
    description: new FormControl(''),
    flatDiscount: new FormControl('', [FormValidatorService.getNumbersOnlyValidator()]),
    discountPercent: new FormControl('', [FormValidatorService.getNumbersOnlyValidator()]),
    memberGroups: new FormControl('', Validators.required)
  });

  newDiscountCode = new DiscountCode();
  loading = false;
  selectedMemberGroups: string[];
  memberGroupsOptions: string[]


  constructor(
    public dialogRef: MatDialogRef<AddDiscountCodeDialogComponent>,
    private applicationService: ApplicationService,
    private discountCodeService: DiscountCodeService,
    private _snackBar: MatSnackBar) { }

  ngOnInit() {
    this.getMemberTypes();
    this.formGroup.setValidators([FormValidatorService.getDateValidator('beginDate', 'endDate')]);

  }

  getMemberTypes() {
    this.loading = true;
    this.applicationService.getAllMemberApplicationTypes().pipe(
      finalize(() => {
        this.loading = false;
      })).subscribe({
        next: (x) => {
          const codes = Array.from(new Set(x.map(y => y.memberType.code)));
          this.memberGroupsOptions = codes as string[];
        },
        error: () => {
          alert("Error in loading.")
          this.closeDialog();
        }
      });
  }

  onSubmit() {
    this.loading = true;
    var discountCodeRequest = this.mapToDiscountCodeRequest(this.formGroup);

    this.discountCodeService.addNewDiscountCode(discountCodeRequest).pipe(
      finalize(() => {
        this.loading = false;
      })).
      subscribe({
        next: () => {
          this.openSnackBar("Successfully Added!");
          this.closeDialog();
        },
        error: (err) => {
          if (err.status === 409) {
            alert("Error in creating. Duplicate code.")
          } else {
            alert("Error on adding new code.");
          }
        }
      })
  }

  closeDialog() {
    this.dialogRef.close();
  }

  showerrors() {
    this.formGroup.get('flatDiscount').errors
    this.formGroup.updateValueAndValidity();
    console.log(this.formGroup.get('flatDiscount').getError('numbersOnly'))
  }

  mapToDiscountCodeRequest(formGroup: FormGroup): DiscountCode {

    console.log(formGroup.controls['discountPercent'].value);

    let discountCodeRequest = new DiscountCode();
    discountCodeRequest.id = 0;
    discountCodeRequest.description = formGroup.controls['description'].value;
    discountCodeRequest.discountPercent = formGroup.controls['discountPercent'].value === '' ? null : formGroup.controls['discountPercent'].value;
    discountCodeRequest.flatDiscount = formGroup.controls['flatDiscount'].value === '' ? null : formGroup.controls['flatDiscount'].value;
    discountCodeRequest.effectiveBeginDate = formGroup.controls['beginDate'].value;
    discountCodeRequest.effectiveEndDate = formGroup.controls['endDate'].value;
    discountCodeRequest.marketCode = formGroup.controls['discountCode'].value;
    discountCodeRequest.memberGroups = formGroup.controls['memberGroups'].value;

    return discountCodeRequest;
  }

  openSnackBar(message: string) {
    this._snackBar.open(message, "Dismiss", { duration: 3000 });
  }

  invalidDateField(): boolean {
    if (this.formGroup.controls['beginDate'].value && this.formGroup.controls['endDate'].value &&
      this.formGroup.hasError('before')) {
      return true;
    }
    return false;
  }
}
